"use client";

import { useRef, type ReactNode } from "react";

type BentoCardProps = {
  children: ReactNode;
  className?: string;
  glow?: boolean;
  as?: "div" | "article" | "section";
};

export function BentoCard({
  children,
  className = "",
  glow = true,
  as: Tag = "div",
}: BentoCardProps) {
  const ref = useRef<HTMLDivElement>(null);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty("--mouse-x", `${e.clientX - rect.left}px`);
    el.style.setProperty("--mouse-y", `${e.clientY - rect.top}px`);
  };

  return (
    <Tag
      ref={ref}
      onMouseMove={handleMouseMove}
      className={`bento-card ${glow ? "glow-border" : ""} ${className}`}
    >
      {children}
    </Tag>
  );
}
